import React from "react";
import { useNavigate } from "react-router-dom";
import "./SearchTypeSwitcher.css";

/**
 * Search-type dropdown for the public search surface. Sits as the FIRST field
 * in the search-inputs row: [ Instructors v ] [ query ] [ location ] [ Search ].
 *
 * Changing the selection NAVIGATES to that search type's page (peer routes) —
 * it is not a client-side filter. The page title updates because each type is
 * its own page.
 */
const TYPES = [
    { key: "instructors", label: "Instructors", path: "/instructors" },
    { key: "schools", label: "Schools", path: "/schools" },
    { key: "events", label: "Events", path: "/events" },
];

const SearchTypeSwitcher = ({ active }) => {
    const navigate = useNavigate();

    const handleChange = (e) => {
        const target = TYPES.find((t) => t.key === e.target.value);
        if (target && target.key !== active) navigate(target.path);
    };

    return (
        <select
            className="search-type-select"
            value={active}
            onChange={handleChange}
            aria-label="Search type"
        >
            {TYPES.map((t) => (
                <option key={t.key} value={t.key}>
                    {t.label}
                </option>
            ))}
        </select>
    );
};

export default SearchTypeSwitcher;
